module.exports = __webpack_public_path__ + "img/2.3b0368aa.png";